import { createContext } from 'react';

/** Null while the flag loads. */
export const GiftPassesEnabledContext = createContext<boolean | null>(null);
